import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileAlt, FaUsers, FaEnvelope, FaChartLine } from 'react-icons/fa';

const DashboardHome = () => {
  const stats = [
    {
      icon: <FaFileAlt className="text-4xl" />,
      title: 'Total Pages',
      value: '5',
      color: 'bg-blue-500',
    },
    {
      icon: <FaUsers className="text-4xl" />,
      title: 'Team Members',
      value: '12',
      color: 'bg-green-500',
    },
    {
      icon: <FaEnvelope className="text-4xl" />,
      title: 'Messages',
      value: '24',
      color: 'bg-yellow-500',
    },
    {
      icon: <FaChartLine className="text-4xl" />,
      title: 'Site Visits',
      value: '1.2k',
      color: 'bg-purple-500',
    },
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Dashboard Overview</h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-xl shadow-md p-6">
            <div className={`${stat.color} text-white w-16 h-16 rounded-lg flex items-center justify-center mb-4`}>
              {stat.icon}
            </div>
            <h3 className="text-gray-600 text-sm mb-1">{stat.title}</h3>
            <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-8">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Link to="/admin/pages" className="bg-maroon-700 hover:bg-maroon-800 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 text-center">
            Manage Pages
          </Link>
          <Link to="/admin/team" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 text-center">
            Manage Team
          </Link>
          <Link to="/admin/messages" className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 text-center">
            View Messages
          </Link>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Recent Activity</h2>
        <div className="space-y-4">
          <div className="flex items-start border-b border-gray-200 pb-4">
            <div className="bg-blue-100 text-blue-600 w-10 h-10 rounded-full flex items-center justify-center mr-4">
              <FaFileAlt />
            </div>
            <div>
              <p className="font-semibold text-gray-800">New page created</p>
              <p className="text-sm text-gray-600">Services page was updated - 2 hours ago</p>
            </div>
          </div>
          <div className="flex items-start border-b border-gray-200 pb-4">
            <div className="bg-green-100 text-green-600 w-10 h-10 rounded-full flex items-center justify-center mr-4">
              <FaUsers />
            </div>
            <div>
              <p className="font-semibold text-gray-800">Team member added</p>
              <p className="text-sm text-gray-600">John Doe was added to the team - 5 hours ago</p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="bg-yellow-100 text-yellow-600 w-10 h-10 rounded-full flex items-center justify-center mr-4">
              <FaEnvelope />
            </div>
            <div>
              <p className="font-semibold text-gray-800">New message received</p>
              <p className="text-sm text-gray-600">Contact form submission - 1 day ago</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
